import React, { SVGProps } from 'react'
export const FourthDefaultRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M10.055 5.351C7.259 3.361 3.646 2.404 0 2V1c3.725.413 7.63 1.432 10.616 3.558 3.009 2.143 5.11 5.394 5.333 10.185.397 8.575-1.544 13.918-4.67 17.112C8.157 35.047 3.943 36 0 36l.002-.972c3.805 0 7.716-.921 10.585-3.854 2.867-2.93 4.784-7.961 4.393-16.385-.208-4.483-2.152-7.463-4.925-9.438Z"
      clipRule="evenodd"
    />
  </svg>
)
